import React, { useEffect } from 'react';
import MasterPageAbstract from './master-page-abstract';
import { MasterPageType } from '../../constants/top-bar-constants';
import ContactsPageSideBar from '../../modules/contacts/components/contacts-page-side-bar';
import ContactsPageMainArea from '../../modules/contacts/components/contacts-page-main-area';
import { registerContactsSelector, updateContactsPageData } from '../../modules/contacts/stores/contacts-slice-handler';

/**
 * The master page linked with the Contacts menu action.
 * @return {JSX.Element}
 * @constructor
 */
export default function MasterPageContacts() {
    return (
        <MasterPageAbstract
            masterPageType={MasterPageType.CONTACTS}
            sideBarContent={<ContactsPageSideBar />}
            mainAreaContent={<ContactsPageMainArea />}
        />
    );
}
